<h3 mat-dialog-title>{{ data.transaction.transactionDateString + ' Deposit Details' }}</h3>

<mat-dialog-content>
    <div class="card">
        <div class="card-body p-0">
            <table class="table">
                <thead>
                <tr>
                    <th>Deposit Date</th>
                    <th>Deposit Account</th>
                    <th class="text-right">Amount</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{{data.transaction.transactionDateString}}</td>
                    <td [innerHTML]="data.bankAccountName"></td>
                    <td [innerHTML]="data.transaction.amount | legfiBalance:'USD':'symbol':'.2'"
                        class="text-right"></td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="card">
        <div class="card-header">
            <h2>Category Breakdown</h2>
        </div>
        <div class="card-body p-0">
            <table class="table">
                <thead>
                <tr>
                    <th>Category</th>
                    <th class="text-right">Amount</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let byCat of depositAmountByCategory">
                    <td>{{byCat.name}}</td>
                    <td [innerHTML]="byCat.amount | legfiBalance:'USD':'symbol':'.2'" class="text-right"></td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="card">
        <div class="card-header">
            <h2>Charges Paid</h2>
        </div>
        <ng-template [ngForOf]="depositItemsByPayor" let-i="index" let-payor ngFor>
            <div [class.mt-4]="i > 0" class="card-header d-flex justify-content-between">
                <h2>{{payor.payor}}</h2>
                <h2 class="mr-3">
                    Total Paid:
                    <span [innerHTML]="payor.total | legfiBalance:'USD':'symbol':'.2'"></span>
                </h2>
            </div>
            <div class="card-body p-0">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Charge Title</th>
                            <th>Category</th>
                            <th class="text-right">Amount Paid</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of payor.items">
                            <td *ngIf="item.payableType === 'App\\Models\\Entities\\Charge'">{{item.payable.title}}</td>
                            <td *ngIf="item.payableType !== 'App\\Models\\Entities\\Charge'">Account Credit</td>
                            <td *ngIf="item.payableType === 'App\\Models\\Entities\\Charge'">
                                {{item.payable.category.name}}</td>
                            <td *ngIf="item.payableType !== 'App\\Models\\Entities\\Charge'">--</td>
                            <td class="text-right">
                                <span [innerHTML]="item.amount | legfiBalance:'USD':'symbol':'.2'"></span>
                                <span *ngIf="item.deletedAt"> (Returned)</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-template>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <app-button mat-dialog-close>{{'Close'}}</app-button>
</mat-dialog-actions>
